import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "relative bg-gray-50 pt-16 pb-20 px-4 sm:px-6 lg:pt-24 lg:pb-28 lg:px-8" }
const _hoisted_2 = { class: "relative max-w-7xl mx-auto" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl" }, "Learning center")
], -1)
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "mt-12 mb-16 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none" }
const _hoisted_6 = ["src", "alt", "title"]
const _hoisted_7 = { class: "flex-1 bg-white p-6 flex flex-col justify-between" }
const _hoisted_8 = { class: "flex-1" }
const _hoisted_9 = { class: "text-sm font-medium text-indigo-600" }
const _hoisted_10 = { class: "text-xl font-semibold text-gray-900" }
const _hoisted_11 = { class: "mt-3 text-base text-gray-500" }
const _hoisted_12 = { class: "mt-6 flex items-center" }
const _hoisted_13 = { class: "flex-shrink-0" }
const _hoisted_14 = { class: "sr-only" }
const _hoisted_15 = ["src", "alt"]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "sr-only" }
const _hoisted_18 = ["src", "alt"]
const _hoisted_19 = { class: "ml-3" }
const _hoisted_20 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "flex space-x-1 text-sm text-gray-500" }
const _hoisted_23 = ["datetime"]
const _hoisted_24 = ["datetime"]

import HeaderComponent from '@/components/layout/HeaderComponent.vue';
import FooterComponent from '@/components/layout/FooterComponent.vue';
import MetaTags from '@/components/MetaTags.vue';
import WhatIsADnsZone from '@/views/learning/WhatIsADnsZone.vue';
import WhatIsTheDnsRootZone from '@/views/learning/WhatIsTheDnsRootZone.vue';
import RecursiveVersusAuthoritativeDns from '@/views/learning/RecursiveVsAuthoritativeDns.vue';
import ZoneDelegation from '@/views/learning/ZoneDelegation.vue';
import HowDoesDomainNameRegistrationWork from '@/views/learning/HowDoesDomainNameRegistrationWork.vue';
import DnsChanger from '@/views/learning/security/DnsChanger.vue';
import DnsRecordTypes from '@/views/learning/DnsRecordTypes.vue';
import RecordTypeTxt from '@/views/learning/DnsRecordTypes/RecordTypeTxt.vue';
import RecordTypeSoa from '@/views/learning/DnsRecordTypes/RecordTypeSoa.vue';
import RecordTypeNs from '@/views/learning/DnsRecordTypes/RecordTypeNs.vue';
import RecordTypeMx from '@/views/learning/DnsRecordTypes/RecordTypeMx.vue';
import RecordTypeCname from '@/views/learning/DnsRecordTypes/RecordTypeCname.vue';
import RecordTypeA from '@/views/learning/DnsRecordTypes/RecordTypeA.vue';
import RecordTypeAAAA from '@/views/learning/DnsRecordTypes/RecordTypeAAAA.vue';
import RecordTypeSrv from '@/views/learning/DnsRecordTypes/RecordTypeSrv.vue';
import RecordTypePtr from '@/views/learning/DnsRecordTypes/RecordTypePtr.vue';
import TipsForPickingADomainName from '@/views/learning/domain-names/TipsForPickingADomainName.vue';
import EmailSecuritySpf from '@/views/learning/EmailSecurity/EmailSecuritySpf.vue';
import EmailSecurityDkim from '@/views/learning/EmailSecurity/EmailSecurityDkim.vue';
import EmailSecurityDmarc from '@/views/learning/EmailSecurity/EmailSecurityDmarc.vue';
import EmailSecurityHowToMergeDmarcRecords from '@/views/learning/EmailSecurity/EmailSecurityHowToMergeDmarcRecords.vue';
import MxVsSpfVsDmarcVsDkimVsBimi from '@/views/learning/MxVsSpfVsDmarcVsDkimVsBimi.vue';
import EmailSecurityUsingDifferentDmarcRecordsForSubdomains from '@/views/learning/EmailSecurity/EmailSecurityUsingDifferentDmarcRecordsForSubdomains.vue';
import { formatDate } from '@/common/dateTime';
import WhatIsDns from '@/views/learning/WhatIsDns.vue';
import TheLifeOfADnsQueryInKubernetes from '@/views/learning/TheLifeOfADnsQueryInKubernetes.vue';
import HowToSpecifyADnsServerInNslookup from '@/views/learning/command-line/HowToSpecifyADnsServerInNslookup.vue';
import WhatIsADnsResolver from '@/views/learning/WhatIsADnsResolver.vue';
import DnsPropagationDoesNotExist from '@/views/learning/DnsPropagationDoesNotExist.vue';
import WhatIsAGoodTtlForDns from '@/views/learning/WhatIsAGoodTtlForDns.vue';
import FindingWhoisServersUsingSrvRecords from '@/views/learning/FindingWhoisServersUsingSrvRecords.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LearningView',
  setup(__props) {

const sections = [
  {
    heading: 'DNS concepts',
    articles: [
      WhatIsDns.meta,
      WhatIsADnsResolver.meta,
      WhatIsADnsZone.meta,
      ZoneDelegation.meta,
      WhatIsTheDnsRootZone.meta,
      RecursiveVersusAuthoritativeDns.meta,
      DnsRecordTypes.meta,
      DnsPropagationDoesNotExist.meta,
    ],
  },
  {
    heading: 'DNS record types',
    articles: [
      RecordTypeNs.meta,
      RecordTypeCname.meta,
      RecordTypeMx.meta,
      RecordTypeTxt.meta,
      RecordTypeA.meta,
      RecordTypeAAAA.meta,
      RecordTypeSoa.meta,
      RecordTypeSrv.meta,
      RecordTypePtr.meta,
    ],
  },
  {
    heading: 'Email and the DNS',
    articles: [
      EmailSecuritySpf.meta,
      EmailSecurityDkim.meta,
      EmailSecurityDmarc.meta,
      MxVsSpfVsDmarcVsDkimVsBimi.meta,
      EmailSecurityHowToMergeDmarcRecords.meta,
      EmailSecurityUsingDifferentDmarcRecordsForSubdomains.meta,
      RecordTypeMx.meta,
    ],
  },
  {
    heading: 'Domain names',
    articles: [
      HowDoesDomainNameRegistrationWork.meta,
      TipsForPickingADomainName.meta,
      FindingWhoisServersUsingSrvRecords.meta,
    ],
  },
  {
    heading: 'Operations',
    articles: [
      TheLifeOfADnsQueryInKubernetes.meta,
      WhatIsAGoodTtlForDns.meta,
    ],
  },
  {
    heading: 'Command line tools',
    articles: [
      HowToSpecifyADnsServerInNslookup.meta,
    ],
  },
  {
    heading: 'Security',
    articles: [
      DnsChanger.meta,
    ],
  },
];

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _createVNode(MetaTags, {
        title: "Learning Center — NsLookup.io",
        description: "Learn about DNS with our free content.",
        url: "https://www.nslookup.io/learning/",
        img1024x512: "https://www.nslookup.io/img/learning/learning-center-social.jpg",
        img1200x630: "https://www.nslookup.io/img/learning/learning-center-social.jpg"
      })
    ])),
    _createVNode(HeaderComponent),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sections, (section) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: section.heading
          }, [
            _createElementVNode("h2", {
              id: section.heading.toLowerCase().replaceAll(' ', '-'),
              class: "mt-12 text-3xl font-semibold text-gray-900"
            }, _toDisplayString(section.heading), 9, _hoisted_4),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.articles, (post) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: post.title,
                  class: "flex flex-col rounded-lg shadow-lg overflow-hidden"
                }, [
                  _createVNode(_component_router_link, {
                    to: post.url,
                    class: "flex-shrink-0"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        class: "h-[207px] w-full bg-white object-cover",
                        src: post.overviewImage,
                        alt: post.overviewImageAlt,
                        title: post.overviewImageAlt
                      }, null, 8, _hoisted_6)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("p", _hoisted_9, [
                        _createElementVNode("span", null, _toDisplayString(post.tag), 1)
                      ]),
                      _createVNode(_component_router_link, {
                        to: post.url,
                        class: "block mt-2"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_10, _toDisplayString(post.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _createElementVNode("p", _hoisted_11, _toDisplayString(post.overviewDescription), 1)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        (post.author.url)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: post.author.url
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_14, _toDisplayString(post.author.name), 1),
                                _createElementVNode("img", {
                                  class: "h-10 w-10 rounded-full",
                                  src: post.author.img,
                                  alt: `Post by ${post.author.name}`
                                }, null, 8, _hoisted_15)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_16, [
                              _createElementVNode("span", _hoisted_17, _toDisplayString(post.author.name), 1),
                              _createElementVNode("img", {
                                class: "h-10 w-10 rounded-full",
                                src: post.author.img,
                                alt: `Post by ${post.author.name}`
                              }, null, 8, _hoisted_18)
                            ]))
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("p", _hoisted_20, [
                          (post.author.url)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: post.author.url,
                                class: "hover:underline"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(post.author.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(post.author.name), 1))
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          (post.updated)
                            ? (_openBlock(), _createElementBlock("time", {
                                key: 0,
                                datetime: post.updated.toISOString()
                              }, _toDisplayString(_unref(formatDate)(post.updated)), 9, _hoisted_23))
                            : (_openBlock(), _createElementBlock("time", {
                                key: 1,
                                datetime: post.written.toISOString()
                              }, _toDisplayString(_unref(formatDate)(post.written)), 9, _hoisted_24))
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ], 64))
        }), 64))
      ])
    ]),
    _createVNode(FooterComponent)
  ], 64))
}
}

})